module.exports = __webpack_public_path__ + "static/BibleBackground-d54ad8e2e08343e47121aed1ab07eae1.jpg";